const BOT_LIST = 'Prerender';

export { BOT_LIST };